import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * PremiumHeader - Header premium cohérent pour toutes les pages
 * Hauteur réduite, design sobre et moderne
 */
const PremiumHeader = ({ 
  title, 
  subtitle, 
  showBackButton = false,
  onBack,
  rightElement = null 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="relative pt-6 pb-3 px-4">
      {/* Gradient overlay léger */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(circle at 50% 0%, rgba(106, 79, 255, 0.15) 0%, transparent 70%)'
        }}
      />
      
      {/* Halo derrière le titre */}
      <div 
        className="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          height: '200px',
          background: 'radial-gradient(ellipse, rgba(106, 79, 255, 0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
          filter: 'blur(40px)'
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-2">
          {showBackButton && (
            <button
              onClick={handleBack}
              className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/[0.06] backdrop-blur-md border border-white/[0.08] hover:bg-white/10 transition-all active:scale-95"
              style={{ boxShadow: '0 0 20px rgba(106, 79, 255, 0.1)' }}
            >
              <ArrowLeft className="w-5 h-5 text-white/90" />
            </button>
          )}
          
          {rightElement && <div className="ml-auto">{rightElement}</div>}
        </div>

        <h1 className="text-xl font-semibold tracking-wide text-white/96 mb-1">
          {title}
        </h1>
        
        {subtitle && (
          <p className="text-sm text-white/60 leading-relaxed max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PremiumHeader;
